export const defaultFilters = () => ({
	starts: '',
	ends: '',
	dateRange: '',
	campaignType: '',
	gamified: false,
	embedOutput: 'all',
	status: '',
	campaignIds: [],
	folder: '',
});
export default {
	folders: [],
	campaigns: [],
	knownCampaignTypes: [],
	knownStatuses: [],
	archives: 0,
	totalCampaignsCount: 0,
	totalFilteredCampaignsCount: 0,
	draftCount: 0,
	publishCount: 0,
	embedFilter: 'all',
	sort: 'newest',
	sortStack: [],
	filters: defaultFilters(),
	search: '',
	searching: false,
	page: 1,
	bulk: [],
	isSelectAll: false,
	error: false,
};
